import { render } from "./createSchedule.vue?vue&type=template&id=a8351872"
import script from "./createSchedule.vue?vue&type=script&lang=js"
export * from "./createSchedule.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__